import {isSearchPage, ProductListState} from "../ProductListProvider";
import {UrlSearchParamsHelper} from "../../../../helpers/urlSearchParamsHelper";
import {isPercentDiscountSetUnderMin} from "./percentDiscountHelper";

export const buildRequestString = (state: ProductListState): string => {
  if (!state.instance) {
    return "";
  }
  const {filter} = state.instance;
  filter.applyFilterValue(state.filters);

  const {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} =
    state.instance.requestParams;

  const initParams = {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} as {
    [k: string]: string | number;
  };

  const initParamsDestination = {};
  Object.keys(initParams)
    .filter(
      (requestParamKey) =>
        typeof initParams[requestParamKey] !== "undefined" &&
        initParams[requestParamKey] !== 0 &&
        requestParamKey !== "offset",
    )
    .forEach((key) => {
      if (key === "limit") {
        const limitSum = Number(initParams[key]) + Number(initParams.offset);
        initParamsDestination[key] = `${limitSum}`;
      } else if (key === "orderBy" && initParams[key] === "innofind" && state.instance?.requestParams.userId) {
        initParamsDestination[key] = initParams[key];
        (initParamsDestination as {userId: string}).userId = state.instance.requestParams.userId as string;
      } else {
        initParamsDestination[key] = initParams[key];
      }
    });

  const filterParams = {};
  Array.from(filter.filterItems.values())
    .filter((filterItem) => filterItem.paramValue)
    .forEach((filterItem) => {
      filterParams[filterItem.field] = filterItem.paramValue.split(",").sort().join(",");
    });

  const urlSearchParams = new URLSearchParams({...filterParams, ...initParamsDestination});

  if (isSearchPage) {
    const possibleSearchQuery = new URLSearchParams(window.location.search).get("q");
    if (possibleSearchQuery) {
      urlSearchParams.append("q", possibleSearchQuery);
    }
    if (UrlSearchParamsHelper.promotions?.id) {
      urlSearchParams.append("promotionId", `${UrlSearchParamsHelper.promotions.id}`);
    }
  }

  const percentDiscountMinValue = isPercentDiscountSetUnderMin(state.instance, state.filters);
  if (percentDiscountMinValue) {
    urlSearchParams.append("percentageDiscount", `${percentDiscountMinValue}-`);
  }

  return urlSearchParams.toString();
};
